import React, { useContext, useState } from 'react';
import { Pressable, Text } from 'react-native';

import AuthContext from 'app/src/contexts/AuthContext';
import { SubNavContainer, LinkContainer, LinkSpace } from 'app/src/elements';
import Modal from 'app/src/elements/Modal';

import NewReconcile from './new';

const SubNav = ({ refetch, selects }) => {
  const { hasPolicy } = useContext(AuthContext);
  const [showAddModal, setShowAddModal] = useState(false);

  return (
    <SubNavContainer>
      <LinkContainer>
        {hasPolicy({ type: 'Reconcile', action: 'create' }) && (
          <>
            <Pressable onPress={() => setShowAddModal(true)} >
              <Text>+ Start Reconciliation</Text>
            </Pressable>
            <LinkSpace />
          </>
        )}
      </LinkContainer>

      {showAddModal &&
        <Modal
          showModal
          setShowModal={setShowAddModal}
          modalType="Start Reconciliation"
        >
          <NewReconcile
            setShowModal={setShowAddModal}
            refetch={refetch}
            selects={selects}
          />
        </Modal>
      }
    </SubNavContainer>
  );
};

export default SubNav;
